import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Глобальный обработчик необработанных ошибок
window.onerror = function(message, source, lineno, colno, error) {
  const errorMsg = `JS Error: ${message}\nSource: ${source}\nLine: ${lineno}:${colno}\nError: ${error?.stack || error}`;
  console.error(errorMsg);
  alert(errorMsg);
  return false;
};

// Глобальный обработчик необработанных промисов
window.onunhandledrejection = function(event) {
  const errorMsg = `Unhandled Promise Rejection: ${event.reason}\nStack: ${event.reason?.stack || 'N/A'}`;
  console.error(errorMsg);
  alert(errorMsg);
};

console.log('🚀 Starting application bootstrap...');

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    console.log('✅ Application bootstrapped successfully');
  })
  .catch((err) => {
    const errorMsg = `❌ Bootstrap Error: ${err.message || err}\nStack: ${err.stack || 'N/A'}`;
    console.error(errorMsg);
    alert(errorMsg);
  });
